import { render, staticRenderFns } from "./BestSellersSlider.vue?vue&type=template&id=619f0c00&scoped=true&"
import script from "./BestSellersSlider.vue?vue&type=script&lang=js&"
export * from "./BestSellersSlider.vue?vue&type=script&lang=js&"
import style0 from "./BestSellersSlider.vue?vue&type=style&index=0&id=619f0c00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619f0c00",
  null
  
)

export default component.exports